import React from 'react';

const LookupComponent = ({ data }) => {
    // Check if the status is "failed" at the top level of the data object
    if (data.status === 'failed') {
        
        return (
            <div className="lookup-cr-container">
                <div className="lookup-header-container">
                    <div className="lookup-header-contents">
                        ERROR
                    </div>
            
                    
                </div>

                <div className="lookup-internal-container">
                    <div className="lookup-text-contents">
                        <span className="lookup-label-header">Message</span>: 
                        <span className="lookup-label-text">{data.message}</span>
                    </div>
                </div>
                
            </div>


           
        );
    };

    // Function to render the data
    const renderData = (obj, objName) => {
        return (
            <div className="lookup-cr-container">
                <div className="lookup-header-container">
                    <div className="lookup-header-contents">
                        {objName.toUpperCase()}
                    </div>
                </div>
                
                <div className="lookup-internal-container">
                    {Object.keys(obj).map(key => (
                        <div key={key}>
                            <div className="lookup-text-contents"><span className="lookup-label-header">{key}</span>: 
                            <span className="lookup-label-text">{String(obj[key])}</span>
                        </div>
                </div>
                ))}
            </div>
        </div>
        );
    };

    return (
        <div>
            {/* Maps each key in the data object to the renderData function */}
            {Object.keys(data).map(key => renderData(data[key], key))}
        </div>
    );
};

export default LookupComponent;
